import React from "react";
//#region types
import { ExpandableListItemActionsProps } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
import ActionLinkButton from "../buttons/actionLinkButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExpandableListItemActions: React.FC<ExpandableListItemActionsProps> = (props) => {
  const handleOnClick = (onClick: (() => Promise<any>) | undefined, event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onClick && onClick();
  };

  return (
    <>
      {props.headerHoverActions?.length ? (
        <Grid item className={cssExports.expandableListItemHoverSubContent}>
          <Grid container direction="row">
            {props.headerHoverActions.map((action, index) => (
              <Grid
                item
                key={index}
                className={
                  index === (props.headerHoverActions && props.headerHoverActions?.length - 1)
                    ? cssExports.expandableListItemFilterLast
                    : ""
                }
              >
                {index ? (
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    className={clsx(
                      cssExports.actionDivider,
                      index > 0 && props.headerHoverActions && props.headerHoverActions[index - 1].showOnExpand
                        ? ""
                        : cssExports.hideOnExpandHover
                    )}
                  />
                ) : (
                  <></>
                )}
                <ActionLinkButton
                  onClick={handleOnClick.bind(null, action.onClickHandler)}
                  className={action.showOnExpand ? "" : cssExports.hideOnExpandHover}
                >
                  {action.description}
                </ActionLinkButton>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default ExpandableListItemActions;
